import React from 'react'
import Footer from './Footer'
import Header from './Header'

//Toastify
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css'
import { Toaster } from "react-hot-toast";
// import Search from '../../pages/Search';
const Layout = (props) => {
    return (
        <>
            <Header />
            {/* <SearchInput/> */}
            <main>
                {/* <ToastContainer /> */}
                <Toaster />
                {props.children}
            </main>
            {/* <Footer /> */}
        </>

    )
}

export default Layout